import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getAvailabilityRequests } from "../src/modules/Booking/reducers";
import { accountBaseUrl } from "../src/helpers/account";

const MustServiceSelectedRoute = ({ children, availabilityRequests }) => {
	return (
		<div>
			{availabilityRequests && availabilityRequests.length > 0 ? (
				<div>{children}</div>
			) : (<Redirect to={accountBaseUrl} />)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	availabilityRequests: getAvailabilityRequests(state.booking),
});

export default connect(mapStateToProps)(MustServiceSelectedRoute);
